var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMoneyBack = function SvgIconMoneyBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#IconMoneyBack_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.936 1.605 9.237.038a.75.75 0 0 0-.474 0L4.064 1.605A3.745 3.745 0 0 0 1.5 5.162V9c0 5.672 6.9 8.805 7.195 8.936a.75.75 0 0 0 .61 0C9.6 17.806 16.5 14.672 16.5 9V5.162a3.745 3.745 0 0 0-2.564-3.557M15 9c0 4.091-4.74 6.775-6 7.417-1.262-.64-6-3.315-6-7.417V5.162a2.25 2.25 0 0 1 1.539-2.134L9 1.54l4.461 1.487A2.25 2.25 0 0 1 15 5.162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.475 6.225-3.14 3.15L6.65 7.62a.75.75 0 1 0-1.08 1.04l1.729 1.8a1.4 1.4 0 0 0 1.009.45h.024a1.4 1.4 0 0 0 1.002-.415l3.204-3.204a.752.752 0 1 0-1.064-1.066"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconMoneyBack_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgIconMoneyBack;